import arrow from "@assets/arrow.svg";
import ToolTip from "../toolTip";
import ChainItem from "./chainItem";
import Echarts from "../echarts";
import CardHead from "../cardHead";
import PricePanel from "../pricePanel";
import "./index.scss";
import { useEffect, useState } from "react";
import { getStakevalueinfo, getStakevaluelist } from "@api/index";
import LoadingOutlined from "@components/loadingOutlined";
import { formateNum, formatNumber, echartslineColor } from "@/tool/utils";
const types = ["USD", "ETH", "FIS"];

export default function Index() {
  const [typevlue, setTypeValue] = useState<string>("USD");

  const [stakeinfo, setStakeinfo] = useState<any>();
  const [stakeinfoLoading, setStakeinfoLoading] = useState<boolean>(false);

  const [updateTime, setUpdateTime] = useState<any>();
  const [yData, setYData] = useState<any>();
  const [echartList, setEchartList] = useState<any[]>([]);
  const [stakelistLoading, setStakelistLoading] = useState<boolean>(false);

  const [hidden, setHidden] = useState<boolean>(false);
  useEffect(() => {
    setStakeinfoLoading(true);
    getStakevalueinfo()
      .then((res) => {
        setStakeinfo(res.data.data);
      })
      .finally(() => {
        setStakeinfoLoading(false);
      });
  }, []);

  useEffect(() => {
    setStakelistLoading(true);
    getStakevaluelist(1, undefined, 1095)
      .then((res) => {
        if (res.data.status == "80000") {
          const data = res.data.data;
          setUpdateTime(data.info.updateTime);
          setYData(data.list[0].stakeValue.yData);
          const list = data.list.map((item: any, index: number) => {
            item.color = echartslineColor[index];
            item.name = item.chainName;
            item.data = item.stakeValue.data.map((item: any) => {
              return Number(item);
            });
            item.type = "line";
            return item;
          });
          setEchartList(list);
        }
      })
      .finally(() => {
        setStakelistLoading(false);
      });
  }, []);

  return (
    <div className="stakedValueContainer">
      <img
        onClick={() => {
          setHidden(!hidden);
        }}
        className={`arrow  ${hidden && "hidden"}`}
        src={arrow}
      />
      <CardHead
        tips={`The overall staked value of StaFi Appchains (Staked value = Token Price x Token Staked Amount).`}
        title="Staked Value"
      />
      <div className={`content ${hidden && "hidden"}`}>
        <LoadingOutlined spin={stakeinfoLoading}>
          {" "}
          <PricePanel
            text={
              stakeinfo
                ? `$${formatNumber(stakeinfo?.info?.stakeValue, {
                    decimals: 2,
                  })}`
                : "--"
            }
          />
        </LoadingOutlined>

        <div className="body">
          <div className="left">
            <div className="left-title">
              Chain Breakdown
              <ToolTip title="Each chain’s overall staked value (Staked value = Token Price x Token Staked Amount)." />
            </div>
            <div className="left-body">
              <LoadingOutlined spin={stakeinfoLoading}>
                {stakeinfo &&
                  stakeinfo?.list.map((item: any) => {
                    return (
                      <ChainItem
                        key={item.chainName}
                        detail={item.detail}
                        text={item.chainName}
                        value={
                          item.stakeValue == 0
                            ? "<$1k"
                            : `$${formatNumber(item.stakeValue, {
                                decimals: 2,
                              })}`
                        }
                      />
                    );
                  })}
              </LoadingOutlined>
            </div>
          </div>
          <div className="right">
            <Echarts
              selectType="node"
              types={types}
              onTypeChange={(value: string) => {
                setTypeValue(value);
              }}
              typeValue={typevlue}
              updateTime={updateTime}
              yData={yData}
              datas={echartList}
              loading={stakelistLoading}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
